import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { KeyboardEvent, useCallback, useEffect, useState } from "react"
import { Input } from "../../components/Input"
import { Load } from "../../components/Load"
import { ICidades } from "../../global/types"
import { useAdmContext } from "../../hooks/useAdmContext"
import { api } from "../../services/api"

type IProps = {
  closeModal: () => void
  handleSelect: (item: ICidades) => void
}

export function CidadesModal({ closeModal, handleSelect }: IProps) {
  const { checkToken } = useAdmContext()

  const [loading, setLoading] = useState(false)
  const [txtLoading, setTxtLoading] = useState("")

  const [pesquisa, setPesquisa] = useState("")
  const [list, setList] = useState<ICidades[]>([])

  const handlePesquisa = useCallback(async (pesq?: string) => {
    setLoading(true)
    setTxtLoading("Pesquisando...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    await api.get(`cidades?limit=25&cursor=0&nome=${pesq}`)
      .then((res) => {
        if (!res.data)
          return

        setList(res.data.result)
      })
      .catch((err) => {
        if (err.response?.data?.message)
          alert(err.response.data.message)
        else
          alert("Erro ao tentar recuperar lista de cadastros. Tente novamente mais tarde")
      })
      .finally(() => {
        setLoading(false)
        setTxtLoading("")
      })

  }, [checkToken])

  const handleKeyPesquisa = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter")
      handlePesquisa(pesquisa);
  }

  const handleClick = (item: ICidades) => {
    handleSelect(item)
    closeModal()
  }

  useEffect(() => {
    handlePesquisa()
  }, [handlePesquisa])

  return (
    <div className="modal">
      <div className="title">
        <p>Lista de Cidades</p>
        <FontAwesomeIcon icon={faTimes} style={{ cursor: "pointer" }} onClick={closeModal} />
      </div>


      <div className="body">
        {loading && (
          <Load txtLoading={txtLoading} />
        )}

        {!loading && (
          <>
            <div className="info">
              <h4>Pesquisa</h4>
            </div>

            <div className="divFormModal">
              <Input
                autoFocus
                mask="none"
                value={pesquisa}
                inputMaskChange={setPesquisa}
                placeholder="Pesquisa..."
                onKeyUp={handleKeyPesquisa}
              />

              <button className="btn-purple" onClick={() => handlePesquisa(pesquisa)}>
                <FontAwesomeIcon icon={faSearch} />
              </button>

              {/*
              <button className="btn-green" onClick={() => setModalCadCliente(true)}>
                <FontAwesomeIcon icon={faPlus} />
              </button>
              */}
            </div>

            <div className="headTable">
              <span>Nome</span>
            </div>
            <div className="contentTable">
              {list.length > 0 && list.map((item) => (
                <div className="rowTable" key={item.id} onClick={() => handleClick(item)}>
                  <span>{item.nome}</span>
                </div>
              ))}

              {list.length === 0 && (
                <h4 style={{ color: "#7E7E7E", fontWeight: "500", textAlign: "center", marginTop: "10px" }}>Pesquise pelo nome do cadastro</h4>
              )}

            </div>

          </>
        )}

      </div>


    </div>
  )
}